import { Main } from './components/containers/Main';

export const ViewClient = () => {
    return <Main />;
};

export default ViewClient;

